import { render, staticRenderFns } from "./wjbgTable.vue?vue&type=template&id=3d434f56&scoped=true"
import script from "./wjbgTable.vue?vue&type=script&lang=js"
export * from "./wjbgTable.vue?vue&type=script&lang=js"
import style0 from "./wjbgTable.vue?vue&type=style&index=0&id=3d434f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d434f56",
  null
  
)

export default component.exports